var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 3.33301H3.33329C2.40829 3.33301 1.67496 4.07467 1.67496 4.99967L1.66663 14.9997C1.66663 15.9247 2.40829 16.6663 3.33329 16.6663H16.6666C17.5916 16.6663 18.3333 15.9247 18.3333 14.9997V4.99967C18.3333 4.07467 17.5916 3.33301 16.6666 3.33301ZM15.8333 14.9997H4.16663C3.70829 14.9997 3.33329 14.6247 3.33329 14.1663V9.99967H16.6666V14.1663C16.6666 14.6247 16.2916 14.9997 15.8333 14.9997ZM16.6666 6.66634H3.33329V5.83301C3.33329 5.37467 3.70829 4.99967 4.16663 4.99967H15.8333C16.2916 4.99967 16.6666 5.37467 16.6666 5.83301V6.66634Z",
    fill: "#F16434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.fdc22e00366bc8a1b3c718597ecc1b0d.svg";
export { ForwardRef as ReactComponent };